import {
  LitElement,
  html,
  TemplateResult,
  css,
  PropertyValues
} from 'lit';
import {customElement, property} from 'lit/decorators';

const enum SizeMode {
  pixel,perc
}

const enum Gravity {
  left,  right
}

@customElement('k-splitter')
export class KeldydraSplitter extends LitElement {

  static styles = css`

    :host {
      display: inline-block;
      --handle-color: #f0f0f0;
      --handle-size: 5px;
    }

    .containers {
      display: flex;
      height: 100%;
    }

    .containers.orientation-vertical {
      display: flex;
      height: 100%;
      flex-direction: column;
    }

    .container {
      position: relative;
    }

    .containers.gravity-0 #container-1 {
      flex: 1 1 0%;
    }

    .containers.gravity-1 #container-0 {
      flex: 1 1 0%;
    }


    .handler {
      background-color: var(--handle-color);
    }

    .orientation-horizontal .handler {
      width: var(--handle-size);
      cursor: ew-resize;
    }

    .orientation-vertical .handler {
      height: var(--handle-size);
      cursor: ns-resize;
    }


  `;


  @property()
  orientation: 'horizontal' | 'vertical' = 'horizontal';

  @property()
  sizes:string;

  containers: HTMLElement;
  resizer: HTMLElement;
  leftSide: HTMLElement;
  rightSide: HTMLElement;

  _mouseMoveHandler: (e: MouseEvent) => void;
  _mouseUpHandler: (e: MouseEvent) => void;

  x = 0;
  y = 0;

  sizeMode:SizeMode = SizeMode.pixel;
  gravity:Gravity = Gravity.right;

  // Width of left side
  private leftWidth = 0;
  private rightWidth = 0;
  private leftHeight = 0;
  private rightHeight = 0;

  constructor() {
    super();
    console.log('constructor');

    this._mouseMoveHandler = (e) => {
      this.mouseMoveHandler(e)
    };
    this._mouseUpHandler = (e) => {
      this.mouseUpHandler(e)
    };


  }

  protected firstUpdated(_changedProperties: PropertyValues) {
    this.initElements();
    if (this.sizes) {
      console.log(this.sizes)
      let size = this.sizes.split(",");
      if (size[0] && size[0] != "*") {
        this.gravity = Gravity.left;
        if (this.orientation == "horizontal") {
          this.leftSide.style.width = size[0];
        } else {
          this.leftSide.style.height = size[0];
        }
      } else {
        this.gravity = Gravity.right;
        if (this.orientation == "horizontal") {
          this.rightSide.style.width = size[1];
        } else {
          this.rightSide.style.height = size[1];
        }
      }

    }
    this.containers.classList.add('gravity-' + this.gravity);
  }


  private mouseDownHandler(e: MouseEvent) {
    this.initElements();

    this.x = e.clientX;
    this.y = e.clientY;

    document.addEventListener('mousemove', this._mouseMoveHandler);
    document.addEventListener('mouseup', this._mouseUpHandler);

    this.leftSide.style.userSelect = 'none';
    this.leftSide.style.pointerEvents = 'none';

    this.rightSide.style.userSelect = 'none';
    this.rightSide.style.pointerEvents = 'none';
  }

  private initElements() {
    this.containers = this.shadowRoot.getElementById('containers');
    this.resizer = this.shadowRoot.getElementById('resizer');
    this.leftSide = this.shadowRoot.getElementById('container-0');
    this.rightSide = this.shadowRoot.getElementById('container-1');

    this.leftWidth = this.leftSide.getBoundingClientRect().width;
    this.leftHeight = this.leftSide.getBoundingClientRect().height;

    this.rightWidth = this.rightSide.getBoundingClientRect().width;
    this.rightHeight = this.rightSide.getBoundingClientRect().height;
  }

  private mouseMoveHandler(e: MouseEvent) {

    // How far the mouse has been moved
    const dx = e.clientX - this.x;
    const dy = e.clientY - this.y;
    this.resize(dx, dy);

    const cursor = this.orientation === 'horizontal' ? 'col-resize' : 'row-resize';


    this.resizer.style.cursor = cursor;
    document.body.style.cursor = cursor;
  };

  protected resize(dx : number = 0, dy: number = 0) {
    if (this.sizeMode === SizeMode.pixel) {
      if (this.orientation == "horizontal") {
        if (this.gravity === Gravity.left) {
          this.leftSide.style.width = String(this.leftWidth + dx) + 'px';
        } else {
          this.rightSide.style.width = String(this.rightWidth - dx) + 'px';
        }
      } else {
        if (this.gravity === Gravity.left) {
          this.leftSide.style.height = String(this.leftHeight + dy) + 'px';
        } else {
          this.rightSide.style.height = String(this.rightHeight - dy) + 'px';
        }
      }
    } else {
      if (this.orientation == "horizontal") {
        const newLeftWidth = (this.leftWidth + dx) * 100 / (this.resizer.parentNode as HTMLElement).getBoundingClientRect().width;
        this.leftSide.style.width = String(newLeftWidth) + '%';
      } else {
        const newLeftHeight = (this.leftHeight + dy) * 100 / (this.resizer.parentNode as HTMLElement).getBoundingClientRect().height;
        this.leftSide.style.width = String(newLeftHeight) + '%';
      }
    }
  }

  private mouseUpHandler(e: MouseEvent) {
    this.resizer.style.removeProperty('cursor');
    document.body.style.removeProperty('cursor');

    this.leftSide.style.removeProperty('user-select');
    this.leftSide.style.removeProperty('pointer-events');

    this.rightSide.style.removeProperty('user-select');
    this.rightSide.style.removeProperty('pointer-events');

    // Remove the handlers of `mousemove` and `mouseup`
    document.removeEventListener('mousemove', this._mouseMoveHandler);
    document.removeEventListener('mouseup', this._mouseUpHandler);

    let resizeEvent = new CustomEvent('resized',{});
    this.dispatchEvent(resizeEvent);
  }


  render(): TemplateResult {
    return html`
        <div id="containers" class="containers orientation-${this.orientation}">
            <div id="container-0" class="container">
                <slot name="0"></slot>
            </div>
            <div id="resizer" class="handler" @mousedown=${this.mouseDownHandler}></div>
            <div id="container-1" class="container">
                <slot name="1"></slot>
            </div>
        </div>
    `;
  }
}

